import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';

const isDevAuth = import.meta.env.VITE_AUTH_MODE === 'dev';

if (isDevAuth) {
  // Dev mode - no Clerk needed
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  // Production mode - use Clerk
  import('@clerk/clerk-react').then(({ ClerkProvider }) => {
    const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

    if (!clerkPubKey) {
      throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY environment variable');
    }

    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <ClerkProvider publishableKey={clerkPubKey}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ClerkProvider>
      </React.StrictMode>
    );
  });
}
